import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'environments/environment'; 
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../Toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  baseURL = environment.apiUrl;
  //replace here only when temporarily pointing the dashboard at a different API host.
  // baseURL = "https://api.b2bmyinvite.com/api/"
  //baseURL = "https://b2bmyinvitetestapi.runasp.net/api/"
  //baseURL = "https://localhost:44327/api/"
  private get token(): string {
    return localStorage.getItem('b2b_token')?.toString() || '';
  }
  private readonly maxPageSize = 100;
  private now = 0
  private expDate = 0

  constructor(private http: HttpClient,private router: Router,private toastService:ToastService) { }

  private normalizePageNumber(pageNumber: number): number {
    const value = Number(pageNumber);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  private normalizePageSize(pageSize: number): number {
    const value = Number(pageSize);

    if (!Number.isFinite(value) || value <= 0) {
      return this.maxPageSize;
    }

    return Math.min(Math.max(value, 1), this.maxPageSize);
  }

  public checkExpiration() {
    // console.log('fff')
    const expDate = localStorage.getItem('b2b_exp')
    // console.log(expDate)
    if (expDate) {
      this.now = Math.floor(Date.now() / 1000)
      if (this.now > parseInt(expDate) && this.token) {
          this.logOut();
      }
    }
    // console.log('Token is still valid.');
    return true;
  }

  public logOut(){
    localStorage.removeItem('b2b_token');
    localStorage.removeItem('b2b_user_data');
    localStorage.removeItem('b2b_username');
    localStorage.removeItem('b2b_exp');
    this.router.navigate(['/login'])
  }

  private handleError(error: HttpErrorResponse) {
    console.log('error' , error.error.message);
    this.toastService.show(error.error.message)
    if (error.status === 401) {
      // Unauthorized - logout the user
      this.logOut();
      // You might want to redirect to login page here or handle it as needed
    }
    return throwError(() => error);
  }

  // Event Category API Functions
  public showAllEventCategory(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/event-categories?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public showEventCategory(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/event-categories/${id}`,{headers: header});
  }
  public deleteEventCategory(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.delete(this.baseURL + `core/event-categories/${id}`,{headers: header});
  }
  public addEventCategory(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.post(this.baseURL + `core/event-categories`,body, {headers: header}); //.pipe(catchError(this.handleError.bind(this)))
  }
  public editEventCategory(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `core/event-categories`,body, {headers: header}); // .pipe(catchError(this.handleError.bind(this)))
  }

  // Login
  public Login(body: any): Observable<any> {
    this.checkExpiration();
    const loginPayload = {
      Email: body.userNameOrPhoneNumber,
      Password: body.password
    };
    return this.http.post(this.baseURL + `auth/login`, loginPayload);
  }

  // Event API Functions
  public showAllEvents(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/events?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public showEventReports(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/event-reports?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public addEvent(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.post(this.baseURL + `core/events`,body, {headers: header});
  }
  public addEventImages(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `core/events/Add-event-photos`,body, {headers: header}).pipe(catchError(this.handleError.bind(this)));
  }
  public getEventById(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/events/${id}`,{headers: header});
  }
  public editEvent(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `core/events`,body, {headers: header}).pipe(catchError(this.handleError.bind(this)));
  }
  public deleteEvent(id: string): Observable<any> {
    this.checkExpiration() 
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.delete(this.baseURL + `core/events/${id}`,{headers: header});
  }

  // Admin API Functions
  public showAllAdmin(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/Account/Get-Users-By-Role?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public showAdmin(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/Account/${id}`,{headers: header});
  }
  public deleteAdmin(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.delete(this.baseURL + `auth/Account/${id}`,{headers: header});
  }
  public switchUserAccessState(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `auth/Account/Switch-User-Access-State`,body, {headers: header});
  }
  public addAdmin(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.post(this.baseURL + `auth/Account/Add-Admin`,body, {headers: header});
  }
  public editAdmin(body: any): Observable<any> {
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `auth/Account/Edit-Admin-Or-Assistant`,body, {headers: header});
  }

  // Offer API Functions
  public showAllOffers(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/Offer?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public showOffer(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/Offer/${id}`,{headers: header});
  }
  public updateOffer(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `core/Offer`,body, {headers: header});
  }
  public changeOfferState(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `core/Offer`,body, {headers: header});
  }
    public changeUserCartItemState(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `core/user-cart-items`,body, {headers: header});
  }
  public deleteOffer(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.delete(this.baseURL + `core/Offer/${id}`,{headers: header});
  }
  public addOffer(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.post(this.baseURL + `core/Offer`,body, {headers: header});
  }

  // Organizers API Functions
  public showAllOrganizers(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/organizers?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public deleteOrganizer(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.delete(this.baseURL + `auth/organizers/${id}`,{headers: header});
  }
  public addOrganizer(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.post(this.baseURL + `auth/organizers`,body, {headers: header});
  }
  public showOrganizerByID(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/organizers/${id}`,{headers: header});
  }
  public updateOrganizer(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `auth/organizers`,body, {headers: header});
  }
    public showOrganizerEventScheduleStatistics(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/organizer-checkinout/Get-Organizers-Event-Schedules-Check-In-And-Out-Statistics?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
      public showScanLogs(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/scan-logs?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public showEventOrganizer(OrganizerId: string,pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/event-organizers/assigned-events?organizerId=${OrganizerId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }

  public addEventsToOrganizer(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.post(this.baseURL + `core/event-organizers/range`,body, {headers: header});
  }

  // Users API Functions
  public showAllUsers(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/Account/Get-Users?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public switchUserState(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `auth/Account/Switch-User-Access-State`,body, {headers: header});
  }
  public deleteUser(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.delete(this.baseURL + `auth/Account/${id}`,{headers: header});
  }
  public userTickets(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/user-cart-items/Filter?UserId=${id}&pageNumber=1&pageSize=100`,{headers: header});
  }
  showUserCartItems(pageNumber: number, pageSize: number) {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/user-cart-items/Filter?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }

  // organizer orders API Functions
  public showAllOrganizerOrders(pageNumber: number,pageSize: number): Observable<any> {
    this.checkExpiration()
    pageNumber = this.normalizePageNumber(pageNumber);
    pageSize = this.normalizePageSize(pageSize);
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/organizers/Filter?pageNumber=${pageNumber}&pageSize=${pageSize}`,{headers: header});
  }
  public showOrganizerOrderDetails(id: string): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/organizers/${id}`,{headers: header});
  }

  // home functions
  public getTotalPayment(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `payment/Payment/Get-Total-Payment`,{headers: header});
  }

  public getPaidRemainingTickets(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `payment/Payment/Get-Paid-Remaining-Tickets`,{headers: header});
  }

  public getPaymentReports(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `payment/Payment/Get-Payment-Reports`,{headers: header});
  }

  public getStatisticsPerLastYear(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `payment/Payment/Get-Statistics-Per-Last-Year`,{headers: header});
  }

  public getStatisticsOfLastMonths(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `payment/Payment/Get-Statistics-Of-Last-Months`,{headers: header});
  }

  public organizerReport(OrganizerId: string,StartTime: String,EndTime: String): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/event-organizers/Filter?OrganizerId=${OrganizerId}&StartTime=${StartTime}&EndTime=${EndTime}&pageNumber=1&pageSize=100`,{headers: header});
  }

  public assignOrganizerToEvent(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.post(this.baseURL + `core/event-organizers`,body, {headers: header});
  }
  public getAssignedOrUnAssignedOrganizer(eventId: string,isAssigned: boolean): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `auth/organizers/Get-Assigned-Or-UnAssigned-Organizer?EventId=${eventId}&IsAssigned=${isAssigned}&pageNumber=1&pageSize=100`,{headers: header});
  }
  public unAssignEventOfOrganizer(body: any): Observable<any> {
    this.checkExpiration();
    const headers = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    };
    const options = {
      headers: headers,
      body: body
    };
    return this.http.delete(this.baseURL + `core/event-organizers/UnAssign-Event-Of-Organizer`, options);
  }

  public totalOrganizersOrders(): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.get(this.baseURL + `core/event-organizers/count`,{headers: header});
  }



  public updateEventStatus(body: any): Observable<any> {
    this.checkExpiration()
    const header = {
      'Accept': 'application/json',
      'Authorization': `Bearer ${this.token}`
    }
    return this.http.put(this.baseURL + `core/events/status`,body, {headers: header});
  }
}
